const BASE_URL = process.env.REACT_APP_API_URL || 'http://103.93.161.255:5200/api';

class ApiService {
  constructor() { this.baseUrl = BASE_URL; }
  getToken() { return localStorage.getItem('ifms_token'); }
  async request(endpoint, options = {}) {
    const token = this.getToken();
    const config = {
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers },
      ...options,
    };
    const res  = await fetch(`${this.baseUrl}${endpoint}`, config);
    const text = await res.text();
    let data;
    try { data = JSON.parse(text); }
    catch { throw new Error(`Server error (${res.status}): ${text.slice(0, 120)}`); }
    if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
    return data;
  }
  get(endpoint)              { return this.request(endpoint); }
  post(endpoint, body)       { return this.request(endpoint, { method: 'POST',   body: JSON.stringify(body) }); }
  put(endpoint, body)        { return this.request(endpoint, { method: 'PUT',    body: JSON.stringify(body) }); }
  patch(endpoint, body)      { return this.request(endpoint, { method: 'PATCH',  body: JSON.stringify(body) }); }
  delete(endpoint)           { return this.request(endpoint, { method: 'DELETE' }); }
  async postForm(endpoint, formData) {
    const token = this.getToken();
    const res   = await fetch(`${this.baseUrl}${endpoint}`, {
      method: 'POST',
      body: formData,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    const text = await res.text();
    let data;
    try { data = JSON.parse(text); } catch { throw new Error(`Server error (${res.status}): ${text.slice(0, 120)}`); }
    if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
    return data;
  }
}

const api = new ApiService();

export const authAPI = {
  login:  (creds) => api.post('/auth/login', creds),
  logout: ()      => api.post('/auth/logout'),
  me:     ()      => api.get('/auth/me'),
};

export const dashboardAPI = {
  summary:          (tahun, unitId) => { const p = new URLSearchParams(); if (tahun) p.set('tahun', tahun); if (unitId) p.set('unit_id', unitId); const qs = p.toString(); return api.get(`/dashboard/summary${qs ? '?' + qs : ''}`); },
  chartSerapan:     (tahun, unitId) => { const p = new URLSearchParams(); if (tahun) p.set('tahun', tahun); if (unitId) p.set('unit_id', unitId); const qs = p.toString(); return api.get(`/dashboard/chart/serapan-bulanan${qs ? '?' + qs : ''}`); },
  chartPengeluaran: (tahun) => api.get(`/dashboard/chart/pengeluaran-per-unit${tahun ? `?tahun=${tahun}` : ''}`),
  transaksiTerbaru: (limit) => api.get(`/dashboard/transaksi-terbaru${limit ? `?limit=${limit}` : ''}`),
  moduleKpi:        (tahun, unitId) => { const p = new URLSearchParams(); if (tahun) p.set('tahun', tahun); if (unitId) p.set('unit_id', unitId); const qs = p.toString(); return api.get(`/dashboard/module-kpi${qs ? '?' + qs : ''}`); },
  search:           (q)     => api.get(`/dashboard/search?q=${encodeURIComponent(q)}`),
  auditTrail:       (qs='') => api.get(`/dashboard/audit-trail${qs}`),
};

export const budgetAPI = {
  getAll:            (qs = '')       => api.get(`/budget${qs}`),
  getById:           (id)          => api.get(`/budget/${id}`),
  create:            (data)          => api.post('/budget', data),
  update:            (id, data)      => api.put(`/budget/${id}`, data),
  checkAvailability:  (anggaran_id, jumlah) =>
    api.get(`/budget/check/availability?anggaran_id=${anggaran_id}&jumlah=${jumlah}`),
  checkHardStop:     (anggaran_id, jumlah) =>
    api.get(`/budget/check/hard-stop?anggaran_id=${anggaran_id}&jumlah=${jumlah}`),
  // Revisi Anggaran
  getRevisiList:  (qs = '')           => api.get(`/budget/revisi/list${qs}`),
  ajukanRevisi:   (id, data)          => api.post(`/budget/${id}/revisi`, data),
  aksiRevisi:     (revisiId, data)    => api.patch(`/budget/revisi/${revisiId}/aksi`, data),
  // Reporting
  getReportSummary: (qs = '')         => api.get(`/budget/report/summary${qs}`),
  getReportByUnit:  (qs = '')         => api.get(`/budget/report/by-unit${qs}`),
  getReportByCoa:   (qs = '')         => api.get(`/budget/report/by-coa${qs}`),
  getReportMonthly: (tahun)          => api.get(`/budget/report/monthly?tahun=${tahun}`),
  export:           (qs = '')         => api.get(`/budget/export${qs}`),
};

export const paymentAPI = {
  getAll:        (qs = '')      => api.get(`/payment${qs}`),
  getById:       (id)           => api.get(`/payment/${id}`),
  create:        (data)         => api.post('/payment', data),
  action:        (id, data)     => api.patch(`/payment/${id}/action`, data),
  uploadDokumen: (id, formData) => api.postForm(`/payment/${id}/dokumen`, formData),
  deleteDokumen: (id, docId)    => api.delete(`/payment/${id}/dokumen/${docId}`),
  downloadUrl:   (id, docId)    => `${BASE_URL}/payment/${id}/dokumen/${docId}/download`,
};

export const penerimaanAPI = {
  getAll:    (qs = '') => api.get(`/penerimaan${qs}`),
  getById:   (id)      => api.get(`/penerimaan/${id}`),
  create:    (data)    => api.post('/penerimaan', data),
  posting:   (id)      => api.patch(`/penerimaan/${id}/posting`, {}),
  getBuku:   (qs = '') => api.get(`/penerimaan/buku${qs}`),
  getKwitansi:(id)     => api.get(`/penerimaan/${id}/kwitansi`),
};

export const pengeluaranAPI = {
  getAll:  (qs = '') => api.get(`/pengeluaran${qs}`),
  getById: (id)      => api.get(`/pengeluaran/${id}`),
  create:  (data)    => api.post('/pengeluaran', data),
  posting: (id)      => api.patch(`/pengeluaran/${id}/posting`, {}),
  getBku:  (qs = '') => api.get(`/pengeluaran/bku${qs}`),
};

export const masterAPI = {
  getVendor:    (qs = '')      => api.get(`/master/vendor${qs}`),
  updateVendor: (id, data)     => api.put(`/master/vendor/${id}`, data),
  getCOA:       (qs = '')      => api.get(`/master/coa${qs}`),
  getUnit:      (qs = '')      => api.get(`/master/unit${qs}`),
  getCostCenter:(qs = '')      => api.get(`/master/cost-center${qs}`),
  getItem:      (qs = '')      => api.get(`/master/item${qs}`),
  getWarehouse: (qs = '')      => api.get(`/master/warehouse${qs}`),
  get:         (entity, qs)   => api.get(`/master/${entity}${qs}`),
  getSumberDana:()             => api.get('/master/sumber_dana'),
  getRekening:  ()             => api.get('/master/rekening'),
  getProgram:   ()             => api.get('/master/program'),
  create:       (entity, data) => api.post(`/master/${entity}`, data),
  // COA Hierarchy
  getCoaProgram:   ()           => api.get('/master/coa/program'),
  getCoaKegiatan:  (qs = '')    => api.get(`/master/coa/kegiatan${qs}`),
  getCoaKro:       (qs = '')    => api.get(`/master/coa/kro${qs}`),
  getCoaAkun:      (qs = '')    => api.get(`/master/coa/akun${qs}`),
  getCoaDetailAkun:(qs = '')    => api.get(`/master/coa/detail-akun${qs}`),
  getCoaDetail:    (qs = '')    => api.get(`/master/coa/detail${qs}`),
  getCoaOptions:   ()           => api.get('/master/coa/options'),
  getCoaTree:      ()           => api.get('/master/coa/tree'),
  createCoaProgram:(data)       => api.post('/master/coa/program', data),
  updateCoaProgram:(id, data)   => api.put(`/master/coa/program/${id}`, data),
  createCoaKegiatan:(data)      => api.post('/master/coa/kegiatan', data),
  updateCoaKegiatan:(id, data)  => api.put(`/master/coa/kegiatan/${id}`, data),
  createCoaKro:    (data)       => api.post('/master/coa/kro', data),
  updateCoaKro:    (id, data)   => api.put(`/master/coa/kro/${id}`, data),
  createCoaAkun:   (data)       => api.post('/master/coa/akun', data),
  updateCoaAkun:   (id, data)   => api.put(`/master/coa/akun/${id}`, data),
  createCoaDetail: (data)       => api.post('/master/coa/detail', data),
  updateCoaDetail: (id, data)   => api.put(`/master/coa/detail/${id}`, data),
  // Rincian (Level 6)
  getCoaRincian:   (qs = '')    => api.get(`/master/coa/rincian${qs}`),
  createCoaRincian:(data)       => api.post('/master/coa/rincian', data),
  updateCoaRincian:(id, data)   => api.put(`/master/coa/rincian/${id}`, data),
};

export const adminAPI = {
  getUsers:        (qs = '')    => api.get(`/admin/users${qs}`),
  createUser:      (data)       => api.post('/admin/users', data),
  updateUser:      (id, data)   => api.patch(`/admin/users/${id}`, data),
  deleteUser:      (id)         => api.delete(`/admin/users/${id}`),
  getAuditLog:     (qs = '')    => api.get(`/admin/audit-logs${qs}`),
  getPeriodeKunci: (qs = '')    => api.get(`/admin/periode-kunci${qs}`),
  kunciPeriode:    (data)       => api.post('/admin/periode-kunci', data),
  getConfig:       ()           => api.get('/admin/config'),
  updateConfig:    (key, value) => api.put(`/admin/config/${key}`, { value }),
  getPermissions:       ()              => api.get('/admin/permissions'),
  getRolePermissions:   ()              => api.get('/admin/permissions/roles'),
  setRolePermissions:   (role, perms)   => api.put(`/admin/permissions/roles/${role}`, { permissions: perms }),
  getUserPermissions:   (userId)        => api.get(`/admin/permissions/users/${userId}`),
  setUserPermissions:   (userId, data)  => api.put(`/admin/permissions/users/${userId}`, data),
};

export const personelAPI = {
  // Personel
  getAll:      (qs = '')        => api.get(`/personel/personel${qs}`),
  getById:     (nrp)            => api.get(`/personel/personel/${nrp}`),
  create:      (data)           => api.post('/personel/personel', data),
  update:      (nrp, data)      => api.put(`/personel/personel/${nrp}`, data),
  delete:      (nrp)            => api.delete(`/personel/personel/${nrp}`),
  // Riwayat
  addDikum:    (nrp, data)      => api.post(`/personel/personel/${nrp}/dikum`, data),
  delDikum:    (id)             => api.delete(`/personel/riwayat/dikum/${id}`),
  addDikmil:   (nrp, data)      => api.post(`/personel/personel/${nrp}/dikmil`, data),
  delDikmil:   (id)             => api.delete(`/personel/riwayat/dikmil/${id}`),
  addJabatan:  (nrp, data)      => api.post(`/personel/personel/${nrp}/jabatan`, data),
  delJabatan:  (id)             => api.delete(`/personel/riwayat/jabatan/${id}`),
  // Lookup
  getKotama:   ()               => api.get('/personel/kotama'),
  addKotama:   (data)           => api.post('/personel/kotama', data),
  updKotama:   (id, data)       => api.put(`/personel/kotama/${id}`, data),
  delKotama:   (id)             => api.delete(`/personel/kotama/${id}`),
  getSatminkal:(qs = '')        => api.get(`/personel/satminkal${qs}`),
  addSatminkal:(data)           => api.post('/personel/satminkal', data),
  updSatminkal:(id, data)       => api.put(`/personel/satminkal/${id}`, data),
  delSatminkal:(id)             => api.delete(`/personel/satminkal/${id}`),
  getRambut:   ()               => api.get('/personel/jenis-rambut'),
  addRambut:   (data)           => api.post('/personel/jenis-rambut', data),
  updRambut:   (id, data)       => api.put(`/personel/jenis-rambut/${id}`, data),
  delRambut:   (id)             => api.delete(`/personel/jenis-rambut/${id}`),
  getKulit:    ()               => api.get('/personel/warna-kulit'),
  addKulit:    (data)           => api.post('/personel/warna-kulit', data),
  updKulit:    (id, data)       => api.put(`/personel/warna-kulit/${id}`, data),
  delKulit:    (id)             => api.delete(`/personel/warna-kulit/${id}`),
  getHrDashboard: ()            => api.get('/personel/hr-dashboard'),
};

export const bagtapyanAPI = {
  // Upload Data
  getUpload:        (qs = '')    => api.get(`/bagtapyan/upload${qs}`),
  uploadFile:       (data)       => api.post('/bagtapyan/upload', {
    tipe_upload: data.tipe_upload,
    jenis_pendidikan: data.jenis_pendidikan,
    kotama_id: data.kotama_id,
    file_nama: data.file?.name || '',
    jumlah_data: 0,
  }),
  // NRP Generation
  getNRP:           (qs = '')    => api.get(`/bagtapyan/nrp${qs}`),
  generateNRP:      (data)       => api.post('/bagtapyan/nrp/generate', data),
  // Salary Assignment
  getGaji:          (qs = '')    => api.get(`/bagtapyan/gaji${qs}`),
  penetapanGaji:    (data)       => api.post('/bagtapyan/gaji/penetapan', { data }),
  // Decisions
  getKeputusan:     (qs = '')    => api.get(`/bagtapyan/keputusan${qs}`),
  createKeputusan:  (data)       => api.post('/bagtapyan/keputusan', data),
  updateKeputusan:  (id, data)   => api.put(`/bagtapyan/keputusan/${id}`, data),
  deleteKeputusan:  (id)          => api.delete(`/bagtapyan/keputusan/${id}`),
  // Distribution
  getDistribusi:    (qs = '')    => api.get(`/bagtapyan/distribusi${qs}`),
  createDistribusi: (data)       => api.post('/bagtapyan/distribusi', data),
  deleteDistribusi: (id)         => api.delete(`/bagtapyan/distribusi/${id}`),
  validasiDistribusi: (id)       => api.patch(`/bagtapyan/distribusi/${id}/validasi`, {}),
  distribusikanData: (id)        => api.patch(`/bagtapyan/distribusi/${id}/distribusikan`, {}),
  // History
  getRiwayat:       (qs = '')    => api.get(`/bagtapyan/riwayat${qs}`),
};

export const binkarAPI = {
  // KP Upload
  getKPUpload:      (qs = '')    => api.get(`/binkar/kp/upload${qs}`),
  createKPUpload:    (data)       => api.post('/binkar/kp/upload', data),
  // Nominatif KP
  getNominatif:     (qs = '')    => api.get(`/binkar/nominatif${qs}`),
  createNominatif:  (data)       => api.post('/binkar/nominatif', data),
  cekNaraya:        (id)         => api.patch(`/binkar/nominatif/${id}/cek-naraya`, {}),
  hitungMDDP:       (id)         => api.patch(`/binkar/nominatif/${id}/hitung-mddp`, {}),
  approveKP:        (id, data)   => api.patch(`/binkar/nominatif/${id}/approve`, data || {}),
  rejectKP:         (id, catatan) => api.patch(`/binkar/nominatif/${id}/reject`, { catatan }),
  deleteNominatif:  (id)         => api.delete(`/binkar/nominatif/${id}`),
  // Pemindahan (Transfer)
  getPemindahan:    (qs = '')    => api.get(`/binkar/pemindahan${qs}`),
  createPemindahan: (data)       => api.post('/binkar/pemindahan', data),
  approvePemindahan:(id, data)   => api.patch(`/binkar/pemindahan/${id}/approve`, data || {}),
  rejectPemindahan: (id, catatan) => api.patch(`/binkar/pemindahan/${id}/reject`, { catatan }),
  deletePemindahan: (id)         => api.delete(`/binkar/pemindahan/${id}`),
  // Penempatan (Placement)
  getPenempatan:    (qs = '')    => api.get(`/binkar/penempatan${qs}`),
  createPenempatan: (data)       => api.post('/binkar/penempatan', data),
  deletePenempatan: (id)         => api.delete(`/binkar/penempatan/${id}`),
  // Gaji (Salary)
  getGaji:          (qs = '')    => api.get(`/binkar/gaji${qs}`),
  createGaji:       (data)       => api.post('/binkar/gaji', data),
  deleteGaji:       (id)         => api.delete(`/binkar/gaji/${id}`),
  // Keputusan (Decision)
  getKeputusan:     (qs = '')    => api.get(`/binkar/keputusan${qs}`),
  createKeputusan:  (data)       => api.post('/binkar/keputusan', data),
  deleteKeputusan:  (id)         => api.delete(`/binkar/keputusan/${id}`),
  // Riwayat (Audit Trail)
  getRiwayat:       (qs = '')    => api.get(`/binkar/riwayat${qs}`),
};

export const tahorAPI = {
  // Master
  getMaster:        ()           => api.get('/tahor/master'),
  createMaster:     (data)       => api.post('/tahor/master', data),
  updateMaster:     (id, data)   => api.put(`/tahor/master/${id}`, data),
  deleteMaster:     (id)         => api.delete(`/tahor/master/${id}`),
  // Upload Tahor
  getUpload:        (qs = '')    => api.get(`/tahor/upload${qs}`),
  createUpload:     (data)       => api.post('/tahor/upload', data),
  // Buku Sidang
  getBukuSidang:    (qs = '')    => api.get(`/tahor/buku-sidang${qs}`),
  // TMT Pemakaian
  getTmt:           (qs = '')    => api.get(`/tahor/tmt${qs}`),
  createTmt:        (data)       => api.post('/tahor/tmt', data),
  updateTmt:        (id, data)   => api.put(`/tahor/tmt/${id}`, data),
  distribusiTahor:  (id)         => api.patch(`/tahor/tmt/${id}/distribusi`, {}),
  // Hasil Sidang
  getHasilSidang:   (qs = '')    => api.get(`/tahor/hasil-sidang${qs}`),
  // Nominatif Usulan
  getNominatif:     (qs = '')    => api.get(`/tahor/nominatif${qs}`),
  // Riwayat
  getRiwayat:       (qs = '')    => api.get(`/tahor/riwayat${qs}`),
  createRiwayat:    (data)       => api.post('/tahor/riwayat', data),
  updateRiwayat:    (id, data)   => api.put(`/tahor/riwayat/${id}`, data),
  postingRiwayat:   (id)         => api.patch(`/tahor/riwayat/${id}/posting`, {}),
  rejectRiwayat:    (id, catatan) => api.patch(`/tahor/riwayat/${id}/reject`, { catatan }),
  deleteRiwayat:    (id)         => api.delete(`/tahor/riwayat/${id}`),
};

export const personelMasterAPI = {
  // Daftar Gaji
  getGaji:          (qs = '')    => api.get(`/personel/daftar-gaji${qs}`),
  addGaji:          (data)       => api.post('/personel/daftar-gaji', data),
  updGaji:          (id, data)   => api.put(`/personel/daftar-gaji/${id}`, data),
  delGaji:          (id)         => api.delete(`/personel/daftar-gaji/${id}`),
  // Data Ruangan
  getRuangan:       (qs = '')    => api.get(`/personel/ruangan${qs}`),
  addRuangan:       (data)       => api.post('/personel/ruangan', data),
  updRuangan:       (id, data)   => api.put(`/personel/ruangan/${id}`, data),
  delRuangan:       (id)         => api.delete(`/personel/ruangan/${id}`),
  // Data Rollpack
  getRollpack:      (qs = '')    => api.get(`/personel/rollpack${qs}`),
  addRollpack:      (data)       => api.post('/personel/rollpack', data),
  updRollpack:      (id, data)   => api.put(`/personel/rollpack/${id}`, data),
  delRollpack:      (id)         => api.delete(`/personel/rollpack/${id}`),
  // Ubah Nama
  getUbahNama:      (qs = '')    => api.get(`/personel/ubah-nama${qs}`),
  addUbahNama:      (data)       => api.post('/personel/ubah-nama', data),
  downloadKepUbahNama: (ids, jenis) => api.post('/personel/ubah-nama/keputusan', { ids, jenis }),
  // Pindah Agama
  getPindahAgama:   (qs = '')    => api.get(`/personel/pindah-agama${qs}`),
  addPindahAgama:   (data)       => api.post('/personel/pindah-agama', data),
  downloadKepAgama: (ids, jenis) => api.post('/personel/pindah-agama/keputusan', { ids, jenis }),
  // Tambah Gelar
  getTambahGelar:   (qs = '')    => api.get(`/personel/tambah-gelar${qs}`),
  addTambahGelar:   (data)       => api.post('/personel/tambah-gelar', data),
  downloadKepGelar: (ids, jenis) => api.post('/personel/tambah-gelar/keputusan', { ids, jenis }),
  // Input Nomor Awal
  getNomorAwal:     ()           => api.get('/personel/nomor-awal'),
  resetNomorAwal:   (id)         => api.patch(`/personel/nomor-awal/${id}/reset`, {}),
  // Master Kopstuk
  getKopstuk:       ()           => api.get('/personel/kopstuk'),
  updateKopstuk:    (data)       => api.put('/personel/kopstuk', data),
};

export const minseldikAPI = {
  getUpload:        (qs = '')    => api.get(`/minseldik/upload${qs}`),
  createUpload:     (data)       => api.post('/minseldik/upload', data),
  getPenilaian:     (qs = '')    => api.get(`/minseldik/penilaian${qs}`),
  createPenilaian:  (data)       => api.post('/minseldik/penilaian', data),
  updatePenilaian:  (id, data)   => api.put(`/minseldik/penilaian/${id}`, data),
  deletePenilaian:  (id)         => api.delete(`/minseldik/penilaian/${id}`),
  getHistory:       (qs = '')    => api.get(`/minseldik/history${qs}`),
};

export const dosirAPI = {
  getDashboard:     ()           => api.get('/dosir/dashboard'),
  searchPersonel:   (nrp)        => api.get(`/dosir/search-personel?nrp=${nrp}`),
  getLemari:        (qs = '')    => api.get(`/dosir/lemari${qs}`),
  addLemari:        (data)       => api.post('/dosir/lemari', data),
  updLemari:        (id, data)   => api.put(`/dosir/lemari/${id}`, data),
  delLemari:        (id)         => api.delete(`/dosir/lemari/${id}`),
  getRak:           (qs = '')    => api.get(`/dosir/rak${qs}`),
  addRak:           (data)       => api.post('/dosir/rak', data),
  updRak:           (id, data)   => api.put(`/dosir/rak/${id}`, data),
  delRak:           (id)         => api.delete(`/dosir/rak/${id}`),
  getRollpack:      ()           => api.get('/dosir/rollpack'),
};

export const doselAPI = {
  getDashboard:     ()           => api.get('/dosel/dashboard'),
  getFolder:        (qs = '')    => api.get(`/dosel/folder${qs}`),
  addFolder:        (data)       => api.post('/dosel/folder', data),
  updFolder:        (id, data)   => api.put(`/dosel/folder/${id}`, data),
  delFolder:        (id)         => api.delete(`/dosel/folder/${id}`),
  getRekap:         (qs = '')    => api.get(`/dosel/rekap${qs}`),
  getDokumen:       (qs = '')    => api.get(`/dosel/dokumen${qs}`),
  uploadDokumen:    (formData)   => api.postForm('/dosel/dokumen', formData),
  deleteDokumen:    (id)         => api.delete(`/dosel/dokumen/${id}`),
  downloadDokumen: async (id) => {
    const token = api.getToken();
    const res = await fetch(`${api.baseUrl}/dosel/dokumen/${id}/download`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error('Download gagal');
    const blob = await res.blob();
    const disposition = res.headers.get('content-disposition');
    const match = disposition && disposition.match(/filename="?(.+?)"?$/);
    const fname = match ? match[1] : 'document';
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = fname; a.click();
    URL.revokeObjectURL(url);
  },
};

export const pensiunAPI = {
  getPemberian:     (qs = '')    => api.get(`/pensiun/pemberian${qs}`),
  createPemberian:  (data)       => api.post('/pensiun/pemberian', data),
  updatePemberian:  (id, data)   => api.put(`/pensiun/pemberian/${id}`, data),
  approvePemberian: (id)         => api.patch(`/pensiun/pemberian/${id}/approve`, {}),
  rejectPemberian:  (id, catatan) => api.patch(`/pensiun/pemberian/${id}/reject`, { catatan }),
  deletePemberian:  (id)         => api.delete(`/pensiun/pemberian/${id}`),
  getKeputusan:     (qs = '')    => api.get(`/pensiun/keputusan${qs}`),
  createKeputusan:  (data)       => api.post('/pensiun/keputusan', data),
  downloadKeputusan:(id, jenis)  => api.post(`/pensiun/keputusan/${id}/download`, { jenis }),
};

export const kekuatanAPI = {
  getDiagram:       (qs = '')    => api.get(`/kekuatan/diagram${qs}`),
  getDiagramKotama: (kotama_id)  => api.get(`/kekuatan/diagram/kotama/${kotama_id}`),
  getPrediksi:      (qs = '')    => api.get(`/kekuatan/prediksi${qs}`),
  getNominatif:     (qs = '')    => api.get(`/kekuatan/nominatif${qs}`),
  getPensiunAktual: (qs = '')    => api.get(`/kekuatan/pensiun-aktual${qs}`),
};

export const assetsAPI = {
  // Asset CRUD
  getAll:           (qs = '')    => api.get(`/assets${qs}`),
  getById:          (id)         => api.get(`/assets/${id}`),
  create:           (data)       => api.post('/assets', data),
  update:           (id, data)   => api.put(`/assets/${id}`, data),
  delete:           (id)         => api.delete(`/assets/${id}`),
  // Financial Linkage
  getVendors:       ()           => api.get('/assets/vendors'),
  getAnggaranAvailable: (tahun) => api.get(`/assets/anggaran-available${tahun ? `?tahun=${tahun}` : ''}`),
  getPaymentRequests: (filters)  => {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.vendor_id) params.append('vendor_id', filters.vendor_id);
    return api.get(`/assets/payment-requests?${params.toString()}`);
  },
  // Categories
  getCategories:    ()           => api.get('/assets/categories'),
  createCategory:   (data)       => api.post('/assets/categories', data),
  updateCategory:   (id, data)   => api.put(`/assets/categories/${id}`, data),
  // Depreciation
  getDepreciation:  (id)         => api.get(`/assets/${id}/depreciation`),
  calculateMonthly: (data)       => api.post('/assets/depreciation/calculate-monthly', data),
  getDepReport:     (qs = '')    => api.get(`/assets/report/depreciation${qs}`),
  // Maintenance
  getAllMaintenance:()            => api.get('/assets/maintenance'),
  getMaintenance:   (id)         => api.get(`/assets/${id}/maintenance`),
  addMaintenance:   (id, data)   => api.post(`/assets/${id}/maintenance`, data),
  updateMaint:      (maint_id, data) => api.put(`/assets/maintenance/${maint_id}`, data),
  // Mutations
  getMutations:     (id)         => api.get(`/assets/${id}/mutations`),
  addMutation:      (id, data)   => api.post(`/assets/${id}/mutations`, data),
  // Dashboard
  getDashboard:     ()           => api.get('/assets/summary/dashboard'),
  // Reports
  getAssetReport:   (qs = '')    => api.get(`/assets/report/assets${qs}`),
  getReportSummary: ()           => api.get('/assets/report/summary'),
  getConditionReport:()          => api.get('/assets/report/condition'),
// SIMAK BMN
  getSyncStatus:    ()           => api.get('/assets/simak-bmn/sync-status'),
  syncTrigger:      ()           => api.post('/assets/simak-bmn/sync-trigger'),
  // Disposal
  getDisposal:      (qs = '')    => api.get(`/assets/disposal${qs}`),
  createDisposal:   (data)       => api.post('/assets/disposal', data),
  approveDisposal:  (id)         => api.patch(`/assets/disposal/${id}/approve`, {}),
};

export const inventoryAPI = {
  // Locations
  getLocations:     ()           => api.get('/inventory/locations'),
  createLocation:   (data)       => api.post('/inventory/locations', data),
  updateLocation:   (id, data)   => api.put(`/inventory/locations/${id}`, data),
  deleteLocation:   (id)         => api.delete(`/inventory/locations/${id}`),
  // Items
  getItems:         (qs = '')    => {
    let params = '';
    if (typeof qs === 'string') params = qs;
    else {
      const p = new URLSearchParams();
      if (qs.search) p.append('search', qs.search);
      if (qs.category) p.append('category', qs.category);
      if (qs.page) p.append('page', qs.page);
      if (qs.limit) p.append('limit', qs.limit);
      params = '?' + p.toString();
    }
    return api.get(`/inventory/items${params}`);
  },
  createItem:       (data)       => api.post('/inventory/items', data),
  updateItem:       (id, data)   => api.put(`/inventory/items/${id}`, data),
  deleteItem:       (id)         => api.delete(`/inventory/items/${id}`),
  // Stock
  getStock:         (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.item_id) params.append('item_id', filters.item_id);
    if (filters.location_id) params.append('location_id', filters.location_id);
    return api.get(`/inventory/stock?${params.toString()}`);
  },
  // Movements
  getMovements:     (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.item_id) params.append('item_id', filters.item_id);
    if (filters.location_id) params.append('location_id', filters.location_id);
    if (filters.movement_type) params.append('movement_type', filters.movement_type);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    return api.get(`/inventory/movements?${params.toString()}`);
  },
  createMovement:   (data)       => api.post('/inventory/movements', data),
  // Receipt
  getReceipts:     ()           => api.get('/inventory/receipt'),
  getReceipt:     (id)         => api.get(`/inventory/receipt/${id}`),
  createReceipt:    (data)       => api.post('/inventory/receipt', data),
  updateReceiptStatus: (id, status) => api.patch(`/inventory/receipt/${id}/status`, { status }),
  // Distribution
  getDistributions:()           => api.get('/inventory/distribution'),
  getDistribution: (id)         => api.get(`/inventory/distribution/${id}`),
  createDistribution: (data)     => api.post('/inventory/distribution', data),
  // Opname
  getOpnames:      ()           => api.get('/inventory/opname'),
  getOpname:      (id)         => api.get(`/inventory/opname/${id}`),
  createOpname:     (data)       => api.post('/inventory/opname', data),
  reconcileOpname:  (id, data)   => api.post(`/inventory/opname/${id}/reconcile`, data),
  // Adjustment
  getAdjustments:   ()           => api.get('/inventory/adjustment'),
  createAdjustment: (data)       => api.post('/inventory/adjustment', data),
  // Dashboard
  getDashboard:     ()           => api.get('/inventory/summary/dashboard'),
};

export const procurementAPI = {
  getAll:           (qs = '')        => api.get(`/procurement${qs}`),
  getById:          (id)             => api.get(`/procurement/${id}`),
  create:           (data)           => api.post('/procurement', data),
  action:           (id, data)       => api.patch(`/procurement/${id}/action`, data),
  sirupCheck:       (id, data)       => api.patch(`/procurement/${id}/sirup-check`, data),
  approvePengadaan: (id)             => api.patch(`/procurement/${id}/approve-pengadaan`, {}),
  linkContract:     (id, data)       => api.patch(`/procurement/${id}/link-contract`, data),
  submitPayment:    (id)             => api.post(`/procurement/${id}/submit-payment`, {}),
  receive:          (id)             => api.post(`/procurement/${id}/receive`, {}),
  complete:         (id)             => api.patch(`/procurement/${id}/complete`, {}),
  getDashboard:     ()               => api.get('/procurement/summary/dashboard'),
};

export const contractAPI = {
  // Contract
  getAll:        (qs = '')   => api.get(`/contract${qs}`),
  getById:       (id)        => api.get(`/contract/${id}`),
  create:        (data)      => api.post('/contract', data),
  update:        (id, data)  => api.put(`/contract/${id}`, data),
  updateStatus:  (id, data)  => api.patch(`/contract/${id}/status`, data),
  addAddendum:   (id, data)  => api.post(`/contract/${id}/addendum`, data),
  addMilestone:  (id, data)  => api.post(`/contract/${id}/milestone`, data),
  getDashboard:  ()          => api.get('/contract/summary/contracts'),
  // Vendor Evaluation
  getEvaluations: (qs = '')  => api.get(`/contract/evaluation${qs}`),
  getEvalById:    (id)       => api.get(`/contract/evaluation/${id}`),
  createEval:     (data)     => api.post('/contract/evaluation', data),
  updateEval:     (id, data) => api.put(`/contract/evaluation/${id}`, data),
  // Vendor History
  getVendorHistory: (vendorId) => api.get(`/contract/vendor/${vendorId}/history`),
};

export const workflowAPI = {
  getAll:       (qs = '')        => api.get(`/workflow${qs}`),
  getById:      (id)             => api.get(`/workflow/${id}`),
  create:       (data)           => api.post('/workflow', data),
  transition:   (id, data)       => api.patch(`/workflow/${id}/transition`, data),
  getDashboard: ()               => api.get('/workflow/summary/dashboard'),
};

export const bendaharaAPI = {
  getPosisiKas:      ()           => api.get('/bendahara/posisi-kas'),
  getJurnal:         (qs = '')     => api.get(`/bendahara/jurnal${qs}`),
  createJurnal:      (data)        => api.post('/bendahara/jurnal', data),
  syncJurnal:        ()            => api.post('/bendahara/jurnal/sync'),
  getBukuKas:        (qs = '')     => api.get(`/bendahara/buku-kas${qs}`),
  rebuildBukuKas:    (data)        => api.post('/bendahara/buku-kas/rebuild', data),
  getRekonsiliasi:   (qs = '')     => api.get(`/bendahara/rekonsiliasi${qs}`),
  createRekonsiliasi:(data)        => api.post('/bendahara/rekonsiliasi', data),
  approveRekonsiliasi:(id)         => api.patch(`/bendahara/rekonsiliasi/${id}/approve`, {}),
  getPeriodeKunci:   (qs = '')     => api.get(`/bendahara/periode-kunci${qs}`),
  lockPeriode:       (data)        => api.post('/bendahara/periode-kunci', data),
  unlockPeriode:     (id)          => api.delete(`/bendahara/periode-kunci/${id}`),
  getConfig:         (tahun)       => api.get(`/bendahara/config${tahun ? `?tahun=${tahun}` : ''}`),
  updateConfig:      (data)        => api.put('/bendahara/config', data),
  getSummary:        (tahun)       => api.get(`/bendahara/summary${tahun ? `?tahun=${tahun}` : ''}`),
};

export const reportsAPI = {
  getTreasury:         (qs = '')  => api.get(`/reports/treasury${qs}`),
  getBudgetRealization:(qs = '')  => api.get(`/reports/budget-realization${qs}`),
  getProcurement:      (qs = '')  => api.get(`/reports/procurement${qs}`),
  getInventory:        (qs = '')  => api.get(`/reports/inventory${qs}`),
  getAsset:            (qs = '')  => api.get(`/reports/asset${qs}`),
  getContract:         (qs = '')  => api.get(`/reports/contract${qs}`),
  getPaymentFlow:      (qs = '')  => api.get(`/reports/payment-flow${qs}`),
  getAuditTrail:       (qs = '')  => api.get(`/reports/audit-trail${qs}`),
  exportReport:        (type, qs) => api.get(`/reports/export/${type}${qs}`),
};

export const hrApprovalAPI = {
  getHistory: (module, refId) => api.get(`/personel/approval-history/${module}/${refId}`),
};

export const notificationAPI = {
  getAll:     ()   => api.get('/notifications'),
  markRead:   (id) => api.patch(`/notifications/${id}/read`, {}),
  markAllRead: ()  => api.patch('/notifications/read-all', {}),
};

export default api;
